import { MoonStars } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { useCodeEditorActions, useColorTheme, useEditorState } from 'src/hooks';
import styles from './DarkThemeButton.module.scss';
import { useEffect } from 'react';

export const DarkThemeButton = () => {
  const { setEditorIsDarkTheme } = useCodeEditorActions();
  const { isEditorDarkTheme } = useEditorState();
  const { isDarkTheme } = useColorTheme();

  useEffect(() => {
    if (isDarkTheme !== isEditorDarkTheme) {
      setEditorIsDarkTheme(isDarkTheme);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDarkTheme]);

  const toggleDarkTheme = () => {
    setEditorIsDarkTheme(!isEditorDarkTheme);
  };

  return (
    <Button
      color={isEditorDarkTheme ? 'tertiary' : 'transparent'}
      onClick={toggleDarkTheme}
      className={styles.root}
    >
      <MoonStars size={SVG_SIZE_M} />
    </Button>
  );
};
